/*
 * @Description: 
 * @Author: xutao
 * @Date: 2021-02-02 16:55:40
 * @LastEditors: xutao
 * @LastEditTime: 2021-02-02 16:57:31
 */
export const ERROR_CODE_ENUM = {
  /**
     * 未登录
     */
  LOGIN: 2419
}
